import { useQuery } from '@tanstack/react-query';
import { CUSTOM_OBJECTS } from '__queries/query-keys';
import { isUUIDValid } from 'ts-components/inputs/ValueInput';
import CustomObjectsService from 'services/CustomObjectsService';
import { useSelector } from 'react-redux';

export const useObjectAPINameLookup = (identifier: string) => {
  const isValidUUID = isUUIDValid(identifier);
  const business = useSelector((s: any) => s.authentication.chosenBusiness);
  const clientObject = business?.client_object;

  const isClientObject = identifier === clientObject?.name;

  const { data, isLoading: loadingId } = useQuery({
    queryKey: CUSTOM_OBJECTS.API_NAME_TO_ID(identifier),
    queryFn: () => {
      if (!isValidUUID) {
        return CustomObjectsService.getObjectIdForAPIName(identifier);
      }

      return identifier;
    },
    enabled: Boolean(identifier) && !isValidUUID && !isClientObject,
  });

  if (isClientObject && clientObject) {
    return {
      loading: false,
      objectId: clientObject.id,
      redirect: true,
    };
  }

  if (isValidUUID) {
    return {
      loading: loadingId,
      objectId: identifier,
      redirect: false,
    };
  }

  return {
    loading: loadingId,
    objectAPIName: identifier,
    objectId: data,
    redirect: !loadingId && Boolean(data),
  };
};
